import { makeStyles } from "tss-react/mui"
import { fas } from "@fortawesome/pro-solid-svg-icons"
import { fal } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconProp, library, SizeProp } from "@fortawesome/fontawesome-svg-core"
import { IconType } from "../../../modules/supplier/admin/account/gdpr/gdprTypes"
import { IconDetails } from "../../../modules/payments/paymentTypes"

library.add(fal, fas)

const useImageStyles = makeStyles()(() => ({
    paymentMethodIconImg: {
        width: "2rem",
    },
}))

type StandardPaymentMethodIconProps = {
    icon?: IconDetails
    size?: SizeProp
}

export function StandardPaymentMethodIcon({ icon, size = "xl" }: StandardPaymentMethodIconProps) {
    const { classes } = useImageStyles()

    if (!icon) {
        return null
    } else if (icon.type === IconType.IMAGE_URL) {
        return <img className={classes.paymentMethodIconImg} src={icon.url} />
    } else if (icon.type === IconType.FONT_AWESOME && icon.spec) {
        return <FontAwesomeIcon icon={icon.spec.split(" ") as IconProp} size={size} color={icon.color} />
    }

    return null
}
